export default __webpack_public_path__ + "static/media/star-coins.73c8a696.png";